<p-image [src]="src" [class]="class + ' menu-logo'" [alt]="alt" height="{{ height }}" width="{{ width }}" />
